<div *ngIf="spinnerService.isLoading | async" class="spinner-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
